// common/schemas/collections/props.js
import { z } from "zod";

const PropSchema = z.object({
    _id: z.string().optional(),
    subscriptionId: z.string(),
    name: z.string().min(1, "Prop name is required."),
    description: z.string().optional().nullable(),
    visualAppearancePrompt: z.string().min(1, "Visual appearance prompt is required."),
    representativeImageRelativePath: z.string().optional().nullable(),
    assetHash: z.string().optional().nullable().describe("A unique hash for cache-busting the representative image."),
    sfxRelativePath: z.string().optional().nullable(),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
    isDirty: z.boolean().optional().default(false).describe("Set to true if the asset needs regeneration."), // ADD THIS LINE

});

export default PropSchema;